Core.Application = function(options) {
    this.version = options.version;
    this.router = new Core.Router(options);
};

_.extend(Core.Application.prototype, Backbone.Events, {

    masterDataCollections: [
        'reportTemplates', 'jobTemplates', 'orderTemplates', 'formTemplates', 'routeTemplates', 'reservationTemplates',
        'myFavourites', 'customers', 'assetTypes', 'assets', 'activities', 'articles', 'phrases', 'labels',
        'places', 'categories', 'users', 'customerTemplates', 'priceLists', 'contracts', 'projects', 'devices',
        'systemMessages'
    ],

    requiredPermissionForMasterData: {
        'users': 'view_other_users',
        'vehicles': 'view_vehicles',
        'jobTemplates': 'create_jobs',
        'orderTemplates': 'create_orders',
        'routeTemplates': 'create_routes',
        'reservationTemplates': 'create_reservations',
        'jobs': 'view_jobs',
        'orders': 'view_orders',
        'routes': 'view_routes',
        'customers': 'view_customers',
        'customerTemplates': 'view_customers',
        'assets': 'view_assets',
        'assetTypes': 'view_assets',
        'reports': 'report_work',
        'reportTemplates': 'report_work',
        'formTemplates': 'view_forms',
        'articles': 'view_articles',
        'contracts': 'view_contracts',
        'projects': 'view_projects',
    },

    run: function() {
        var self = this;
        try {
            localStorage.test = 'foo';
            delete localStorage.test;
        } catch (e) {
            // wkhtmltopdf has no localStorage
            //window.localStorage = {};
            //this.fail('It appears that your browser does not support localStorage.\n' + e);
            //return;
        }
        try {
            sessionStorage.test = 'foo';
            delete sessionStorage.test;
        } catch (e) {
            console.error('No sessionStorage: ' + e);
            this.fail('It appears that your browser does not support sessionStorage.\n' + e);
            return;
        }

        // Generic ajax error handling for when token expires etc
        $(document).ajaxError(function (event, response, settings, error) {
            if (response.status == 0 && response.statusText == 'abort') return;
            console.error('ajax error', settings.url, response);
            if (Core.apiToken && !Core.accessToken && response.status == 401 && (!self.loggedOutTime || new Date().getTime() - self.loggedOutTime > 10000)
                    && (!sessionStorage || !sessionStorage.impersonate) && settings.url.indexOf(Core.contextRoot + '/session') < 0) {
                debug.error('logout due to ajax error');
                self.loggedOutTime = new Date().getTime();
                errorResponse(response.responseText);
                location.hash = 'logout';
            }
        });

        this.openSocket();

        Backbone.history.start();
        $(window).resize(_.debounce(function() {
            debug.log('window resize');
            if (self.navbar) {
                self.navbar.resizeView();
                self.navbar.render();
            }
            if (self.view && self.view.resizeView) self.view.resizeView();
        }, 200));

        window.onbeforeprint = function() {
            debug.log('before print');
            window.isPrinting = true;
            if (window.view) window.view.render();
        }
        window.onafterprint = function() {
            debug.log('after print');
            window.isPrinting = false;
            if (window.view) window.view.render();
        }
    },

    load: function(callback, context) {
        this.loadInternationalization(function() {
            this.loadTemplates(function() {
                this.loadGoogleApi(function () {
                    this.loadViews(function () {
                        callback.apply(context || this);
                        this.tick();
                    }, this);
                }, this);
            }, this);
        }, this);
    },

    loadInternationalization: function (callback, context) {
        debug.log('load: internationalization');
        $('pre.app-loading').append('\nLoading internationalization...');

        var self = this;
        i18next
            .use(i18nextBrowserLanguageDetector)
            .use(i18nextXHRBackend)
        .init({
            fallbackLng: 'en',
            ns: [ 'translation', 'things', 'billing', 'connect' ],
            backend: {
                loadPath: 'locales/{{lng}}/{{ns}}.json?v=' + self.version,
                crossDomain: true
            },
            detection: {
                order: [ 'querystring', 'navigator' ],
                lookupQuerystring: 'language'
            },
            debug: false
        }, function (errors, t) {
            debug.log('i18n initialized', i18next.language, errors);

            var loadLanguage = function(lang) {
                debug.log('load language', lang);
                if (lang.indexOf('-') > 0) lang = i18next.language = lang.substring(0, lang.indexOf('-'));
                if (app.navbar && app.navbar.rendered) app.navbar.render();
                if (app.view && app.view.rendered) app.view.render();
            }


            i18next.on('languageChanged', function (lang) {
                debug.log('language changed', lang);
                if (lang.indexOf('-') > 0) lang = lang.substring(0, lang.indexOf('-'));
                Core.language = lang;
                loadLanguage(lang);
            });
            i18next.on('loaded', function (a) {
                debug.log('i18next loaded', a);
                if (self.view) self.view.render();
            });
            i18next.on('failedLoading', function(lang, ns, msg) {
                debug.error('Failed loading language ' + lang + ' namespace ' + ns + ': ' + msg);
            });

            if (i18next.language.indexOf('-') > 0) {
                var lang = i18next.language.substring(0, i18next.language.indexOf('-'));
                debug.log('change language from ' + i18next.language + ' to ' + lang);
                i18next.changeLanguage(lang);
            } else {
                if (i18next.language == '*') i18next.language = 'en';
                Core.language = i18next.language;
                loadLanguage(errors ? 'en' : i18next.language);
            }

            callback.apply(context || self);
        });
    },

    loadTemplates: function (callback, context) {
        debug.log('load: templates');
        $('pre.app-loading').append('\nLoading templates...');
        var self = this;
        $('#templates').load('templates.html?v=' + self.version, function (responseText, textStatus, xhr) {
            if (xhr.status != 200) {
                console.error('failed to load templates', xhr);
                self.fail('Failed to load templates: ' + xhr.responseText);
            } else {
                debug.log('templates loaded');

                // Do some template pre-processing
                $('#language-options').html(Core.template('language-options')());
                $('#country-options').html(Core.template('country-options')());

                callback.apply(context || self);
            }
        });
    },

    loadGoogleApi: function (callback, context) {
        var self = this;
        if (typeof gapi == 'undefined' || typeof gapi.load != 'function') {
            debug.error('google init failed: gapi undefined');
            callback.apply(context || self);
            return;
        }
        return gapi.load('auth2', function() {
            if (typeof gapi.auth2 == 'undefined' || typeof gapi.signin2 == 'undefined') {
                debug.error('google init failed: gapi.auth2 or gapi.signin2 undefined');
                callback.apply(context || self);
                return;
            }
            self.auth2 = gapi.auth2.init({
                scope: 'profile email',
                client_id: Core.googleClientId
            });
            callback.apply(context || self);
        });
    },

    handleCredentialResponse: function(response) {
        if (response.credential) {
            app.googleCredential = response.credential;
            if (this.onGoogleLogin) this.onGoogleLogin(response.credential);
            else debug.error('no onGoogleLogin handler');
        }
    },

    loadViews: function (callback, context) {
        debug.log('load: views');
        $('pre.app-loading').append('\nLoading views...');
        var self = this;
        $.ajax({
            url: 'js/view.min.js?v=' + self.version,
            dataType: 'script',
            cache: true,
        }).done(function (data, textStatus, xhr) {
            debug.log('views loaded');
            document.documentElement.classList.remove('app-loading');
            $('.app-loading').hide();
            $('#body-content').hide().fadeIn(500);
            self.loaded = true;
            callback.apply(context || self);
        }).fail(function (xhr, settings, exception) {
            console.error('failed to load views', xhr, settings, exception);
            self.fail('Failed to load views: ' + xhr.responseText);
        });
    },

    tick: function () {
        debug.log('tick');
        var self = this;
        var interval = 30000;
        var now = new Date().getTime();
        if ((!this.lastVersionCheckTime || now - this.lastVersionCheckTime > 300000) && !window.unsavedChanges) {
            debug.log('check version');
            this.checkVersion();
            this.lastVersionCheckTime = now;
        }

        if (Core.apiToken) {
            // Poll for masterdata
            var pollCount = 0;
            this.masterDataLoaded = true;
            _(this.masterDataCollections).each(function (name) {
                // Limit poll fetches per tick
                if (pollCount >= 1) return;
                var permission = this.requiredPermissionForMasterData[name];
                if (permission && !Core.client.hasPermission(permission)) return;
                var collection = Core.client[name];
                if (!collection || collection.loading || collection.loadingCount) return;
                if (!collection.loaded && !collection.isPaginated()) {
                    // Need to fetch master data
                    if (!collection.getCached()) {
                        var fetched = false;
                        if (collection.getCached(true)) {
                            var age = new Date().getTime() - collection.getCacheExpires();
                            if (age < 24*3600000) {
                                debug.log('tick masterdata outdated cache ' + name);
                                collection.fetchUpdates();
                                fetched = true;
                            }
                        }
                        if (!fetched) {
                            debug.log('tick masterdata fetch ' + name);
                            collection.getCachedOrFetchIfNotPaginated();
                            this.listenToOnce(collection, 'change reset', function() { 
                                app.trigger('masterdata-fetch');
                                setTimeout(function () { app.tick(); }, 100);
                            });
                        }
                        interval = 1000;
                        pollCount++;
                        this.masterDataLoaded = false;
                    }
                } else if (collection.loaded && collection.getCacheExpires() && new Date().getTime() > collection.getCacheExpires()) {
                    debug.log('tick masterdata refresh ' + name);
                    collection.fetchUpdates();
                    interval = 5000;
                    pollCount++;
                }
            }, this);
        }

        if (this.getMasterDataProgress() <= 99 && interval < 1000) interval = 1000;

        if (this.tickTimeout) clearTimeout(this.tickTimeout);
        this.tickTimeout = setTimeout(function() { self.tick(); }, interval);

        if (typeof Sentry != 'undefined' && Core.client.me.loaded && !this.sentryUserSet) {
            var self = this;
            Sentry.configureScope(function (scope) {
                scope.setUser({
                    id: Core.client.me.id,
                    username: Core.client.me.get('fullName'),
                    email: Core.client.me.get('emailAddress'),
                })
                scope.setTag('language', i18next.language);
                scope.setTag('version', self.version);
                scope.setTag('environment', '<%= environment.name %>');
                var primaryGroup = Core.client.primaryGroup();
                if (primaryGroup) {
                    scope.setExtra('primary_group_name', primaryGroup.get('name'));
                    scope.setExtra('primary_group_id', primaryGroup.id);
                }
            });
            debug.log('sentry scope set');
            this.sentryUserSet = true;
        }

        if(!localStorage.groupHasIntegration){
            this.loadGroupIntegrations()
        }
        this.checkSystemMessage();
        this.trigger('tick');
    },

    getMasterDataProgress: function () {
        var loadedCount = 0, totalCount = 0;
        _(this.masterDataCollections).each(function (name) {
            var permission = this.requiredPermissionForMasterData[name];
            if (permission && !Core.client.hasPermission(permission)) return;
            var collection = Core.client[name];
            if (collection) {
                totalCount++;
                if (collection.loaded || collection.isPaginated()) loadedCount++;
            }
        }, this);
        return 100 * loadedCount / totalCount;
    },

    fail: function (message) {
        $('#app-load-fail-modal .modal-body').text(message);
        $('#app-load-fail-modal').modal({
            backdrop: 'static',
            keyboard: false
        });
    },

    login: function (callback, context) {
        var view = this.setMainView(new LoginView());
        this.listenToOnce(view, 'login', function() {
            if (Core.client.me.get('passwordChangeRequired')) {
                this.resumeSession();
                view = this.setMainView(new ChangePasswordView());
                this.listenToOnce(view, 'done', function() {
                    if (callback) callback.apply(context || this);
                });
            } else
                this.resumeSession(callback, context);
        });
    },

    completeLogin: function(response) {
        Core.initialize();
        Core.setupTokens(response.token);
        Core.client.me.set(response.me);
        Core.client.permissions.set({permissions: response.permissions});
        Core.client.groups.reset(response.groups);
        Core.client.me.loaded = Core.client.permissions.loaded = Core.client.groups.loaded = true;

        if (window.localStorage) {
            if (localStorage.me_id && localStorage.me_id != Core.client.me.id) localStorage.clear();
            localStorage.me_id = Core.client.me.id;
        }
        delete sessionStorage.login_credentials;

        if (this.navbar) this.navbar.render();
        this.showNavbar();

        if (location.hash == '#signup') Backbone.history.navigate('#setup', { trigger: true, replace: true });
        else if (Core.client.me.get('extensionServices').length == 0 && Core.client.groups.length == 0) location.hash = '#setup';
        else if (location.hash == '#login' || location.hash == '#eula') location.hash = '';
        else Backbone.history.loadUrl();

        if (Core.client.me.get('language') != i18next.language) i18next.changeLanguage(Core.client.me.get('language'));

        this.tick();

        if (window.localStorage) {
            localStorage.completeLogin = JSON.stringify(response); // tell other tabs - see copy_token.js
        }
        this.openSocket();
    },

    handleLoginError: function(response) {
        if (response.status == 406) {
            if (response.responseText.indexOf('license agreement') >= 0) {
                this.setMainView(new EndUserLicenseAgreementView());
                return true;
            }
            if (response.responseText.indexOf('forcefully cancelled') >= 0) {
                var reason = response.responseText.split('CANCEL_REASON: ')[1];
                this.setMainView(new ForceCancelledView({ reason: reason }));
                return true;
            }
        }
        return false;
    },

    resumeSession: function (callback, context) {
        if (location.search.indexOf('language=') < 0) {
            if (Core.client && Core.client.me && Core.client.me.get('language') && Core.client.me.get('language') != i18next.language) {
                debug.log('post resume language ');
                i18next.changeLanguage(Core.client.me.get('language'));
            } else {
                debug.log('post resume no language');
                this.listenToOnce(Core.client.me, 'change', this.changeMe);
            }
        } else {
            //Override with language from location
            if (location.search.split("language=").length > 1 && location.search.split("language=")[1].length > 1)
                i18next.changeLanguage(location.search.split("language=")[1].substring(0,2));
        }
        if (window.localStorage && localStorage.me_id && Core.client.me.id && localStorage.me_id != Core.client.me.id) {
            debug.error('localStorage me ' + localStorage.me_id + ' and client me ' + Core.client.me.id + ' differ');
            localStorage.clear();
        }
        if (Core.apiToken) this.showNavbar();
        if (callback)
            callback.apply(context || this);
        else
            Backbone.history.loadUrl();
        this.openSocket();
    },

    changeMe: function() {
        if (Core.client.me.get('language') != i18next.language) i18next.changeLanguage(Core.client.me.get('language'));
        if (window.localStorage && localStorage.me_id && Core.client.me.id && localStorage.me_id != Core.client.me.id) {
            debug.error('localStorage me ' + localStorage.me_id + ' and client me ' + Core.client.me.id + ' differ');
            localStorage.clear();
            this.openSocket();
        }
    },

    logout: function (silent) {
        if (Core.apiToken) {
            $.ajax({
                type: 'DELETE',
                url: Core.contextRoot + '/session',
            }).success(function (response) {
                debug.log('session deleted');
            }).error(function (response) {
                debug.error('delete session failed', response);
            });
        }
        this.removeSession(silent);
        if (!silent && window.localStorage) localStorage.clear();
    },

    removeSession: function (silent) {
        debug.log('remove session');
        $(document).off('ajaxSend');
        sessionStorage.clear();
        delete Core.apiToken;
        delete Core.accessToken;
        Core.client = new Core.Client();
        if (this.router) this.router.initialize();
        if (!silent) {
            this.hideNavbar();
            $('html').removeClass('logged-in');
        }
        this.openSocket();
    },

    reloginAllTabs: function () {
        debug.log('reloginAllTabs');
        // see copy_token.js
        if (window.localStorage) localStorage.setItem('relogin', Date.now());
    },

    impersonate: function (user) {
        $('body').hide();
        $('html').removeClass('logged-in');
        //if (sessionStorage.impersonate) this.endImpersonation(true);
        var self = this;
        return $.post(Core.contextRoot + '/session', { user: user, client: 'cdn-web:' + parseInt(app.version/1000) }).success(function (response) {
            debug.log('impersonate success', response);
            self.setupImpersonation(response);
            setTimeout(function () { self.navbar.$('#current-user-link').effect('highlight'); }, 200);
            // tell other tabs
            if (window.localStorage) localStorage.setItem('impersonate', JSON.stringify(response));
        }).error(function (response) {
            errorResponse(response.responseText);
        }).complete(function() {
            $('html').addClass('logged-in');
            $('body').fadeIn(100);
        });
    },

    setupImpersonation: function(response) {
        var oldToken = sessionStorage.impersonate_previousToken || Core.apiToken;
        var oldMe = sessionStorage.impersonate_me || JSON.stringify(Core.client.me.toJSON());
        var oldPermissions = sessionStorage.impersonate_permissions || JSON.stringify(Core.client.permissions.toJSON());
        var oldGroups = sessionStorage.impersonate_groups || JSON.stringify(Core.client.groups.toJSON());
        this.removeSession(true);
        sessionStorage.impersonate = true;
        sessionStorage.impersonate_previousToken = oldToken;
        sessionStorage.impersonate_me = oldMe;
        sessionStorage.impersonate_permissions = oldPermissions;
        sessionStorage.impersonate_groups = oldGroups;
        Core.client.clear();
        Core.initialize();
        Core.setupTokens(response.token);
        Core.client.me.set(response.me);
        Core.client.permissions.set({permissions: response.permissions});
        Core.client.groups.reset(response.groups);
        Core.client.me.loaded = Core.client.permissions.loaded = Core.client.groups.loaded = true;
        this.navbar.render();
        Backbone.history.loadUrl();
        this.tick();
        this.openSocket();
    },

    endImpersonation: function(silent) {
        try {
            var token = sessionStorage.impersonate_previousToken;
            var me = JSON.parse(sessionStorage.impersonate_me);
            var permissions = JSON.parse(sessionStorage.impersonate_permissions);
            var groups = JSON.parse(sessionStorage.impersonate_groups);
            this.logout(true);
            Core.client.clear();
            Core.initialize();
            Core.setupTokens(token);
            Core.client.me.set(me);
            Core.client.permissions.set(permissions);
            Core.client.groups.reset(groups);
            Core.client.me.loaded = Core.client.permissions.loaded = Core.client.groups.loaded = true;
            if (!silent) {
                this.navbar.render();
                this.view.render();
                this.navbar.$('#current-user-link').effect('highlight');
                Backbone.history.loadUrl();
            }
            app.tick();
        } catch (e) {
            // Sometimes when impersonating in multiple tabs and reloading etc... things go wrong.
            window.close();
        }
    },

    openSocket: function () {
        if (typeof WebSocket !== 'function') return; // phantomjs
        if (false || !!document.documentMode) return; // if IE dont open socket
        if (this.socket) {
            debug.log('closing previous socket');
            this.stopListening(this.socket);
            if (this.socket.socket.readyState == WebSocket.CONNECTING){
                this.socket.socket.readyState = WebSocket.CLOSING;
                this.socket = null;
            } else {
                this.socket.destroy();
            }
        };
        var url = '<%= environment.socketUrl %>';
        if (Core.apiToken) url += '?api_token=' + Core.apiToken;
        this.socket = new Backbone.WS(url, { sync: true, keepOpen: true, debug: typeof Core.param('wsdebug') !== 'undefined' });
        debug.log('opening socket', this.socket.url);
        this.listenTo(this.socket, 'ws:message:entityCreated', this.entityCreated);
        this.listenTo(this.socket, 'ws:message:entityUpdated', this.entityUpdated);
        this.listenTo(this.socket, 'ws:message:entityDeleted', this.entityDeleted);
        this.listenTo(this.socket, 'ws:message:locationUpdated', this.locationUpdated);
        this.listenTo(this.socket, 'ws:message:groupMembershipsChanged', this.groupMembershipsChanged);
        this.listenTo(this.socket, 'ws:message:systemMessagesUpdated', this.systemMessageUpdate);
    },

    entityCreated: function(data) {
        var collection = this.getCollectionByEntityClass(data.entityClass, data.template);
        if (!collection) return;
        if (collection.loaded && !collection.isPaginated()) {
            if (!this.entityUpdatedTimeout) this.entityUpdatedTimeout = {};
            this.entityUpdatedTimeout[data.entityClass] = CoreUI.randomTimeout(function () {
                debug.log(data.entityClass + (data.template ? ' template' : '') + ' created - fetching updates');
                collection.fetchUpdates();
            }, 300, 1000, this, this.entityUpdatedTimeout[data.entityClass]);
        }
    },

    entityUpdated: function(data) {
        var collection = this.getCollectionByEntityClass(data.entityClass, data.template);
        if (!collection) return;
        if (collection.loaded && !collection.isPaginated() && (!data.version || !collection.get(data.id) || data.version > collection.get(data.id).get('version'))) {
            if (!this.entityUpdatedTimeout) this.entityUpdatedTimeout = {};
            debug.log(data.entityClass + (data.template ? ' template' : '') + ' updated');
            var self = this;
            if (!this.entityUpdatedTimeout[data.entityClass]){
                this.entityUpdatedTimeout[data.entityClass] = CoreUI.randomTimeout(function () {
                    debug.log(data.entityClass + (data.template ? ' template' : '') + ' updated - fetching updates');
                    delete self.entityUpdatedTimeout[data.entityClass];
                    if (data.entityClass == "Article" && collection.filterParams) collection.filterParams.includeInactiveUpdate = true;
                    collection.fetchUpdates();
                }, Core.MAX_FETCH_RATE + 300, Core.MAX_FETCH_RATE + 1000, this, this.entityUpdatedTimeout[data.entityClass]);
            }
        }
    },

    entityDeleted: function(data) {
        var collection = this.getCollectionByEntityClass(data.entityClass, data.template);
        if (!collection) return;
        if (collection.get(data.id)) {
            debug.log(data.entityClass + (data.template ? ' template' : '') + ' deleted - removing from collection');
            collection.remove(data.id);
            collection.updateCache();
        }
    },

    locationUpdated: function(data) {
        var collection = this.getCollectionByEntityClass(data.entityClass, data.template);
        if (!collection) return;
        if (collection.loaded && collection.get(data.id) && (!data.version || data.version > collection.get(data.id).get('version'))) {
            debug.log(data.entityClass + ' updated location');
            collection.get(data.id).set('location', data.location);
        }
    },

    groupMembershipsChanged: function(data) {
        if (!this.lastReloadMasterData || new Date().getTime() - this.lastReloadMasterData > 3000) {
            debug.log('group memberships changed - reload', data);
            Core.client.me.set(data.me);
            this.reloadMasterData(false);
        }
    },

    systemMessageUpdate: function(data){
        var self = this;
        Core.client["systemMessages"].fetchUpdates().done(function(){
            self.checkSystemMessage(true)
        })
    },

    getCollectionByEntityClass: function(entityClass, template) {
        switch (entityClass) {
            case 'JobOrder': return template ? Core.client.orderTemplates : Core.client.orders;
            case 'Job': return template ? Core.client.jobTemplates : Core.client.jobs;
            case 'Route': return template ? Core.client.routeTemplates : Core.client.routes;
            case 'WorkReport': return template ? Core.client.reportTemplates : Core.client.reports;
            case 'CustomForm': return template && Core.client.formTemplates;
            case 'Customer': return template ? Core.client.customerTemplates : Core.client.customers;
            case 'Article': return Core.client.articles;
            case 'AssetType': return Core.client.assetTypes;
            case 'Asset': return Core.client.assets;
            case 'Activity': return Core.client.activities;
            case 'Category': return Core.client.categories;
            case 'Place': return Core.client.places;
            case 'Phrase': return Core.client.phrases;
            case 'User': return Core.client.users;
            case 'Group': return Core.client.groups;
            case 'Label': return Core.client.labels;
            case 'Contract': return Core.client.contracts;
            case 'Favourite': return Core.client.myFavourites;
            case 'SystemMessage':  return Core.client.systemMessages;
        }
    },

    checkVersion: function () {
        if ($('#new-version').is(':visible')) return;
        var self = this;
        $.ajax({
            cache: false,
            url: "/version.json",
            dataType: "json",
            success: function(data) {
                if (data.version > self.version) {
                    var date = '';
                    try {
                        date = Formatting.date(new Date(parseInt(data.version)));
                    } catch (e) {}
                    debug.log('New version available', data.version, date);
                    $('#new-version').html(Core.template('new-version-template')({
                        date: date
                    })).slideDown(300);
                }
            }
        });
    },

    checkSystemMessage: function (update) {
        if ($('#new-system-message').is(':visible')) {
            var id = $('#new-system-message').attr('system-message-id')
            var current = Core.client.systemMessages.get(id)
            if (!current || (current.get('endTime') != null && current.get('endTime') < Date.now()) || current.get('startTime') > Date.now()){
                document.getElementById('new-system-message').style.display = "none";
            }
            else {
                if(update){
                    if(current.get('filter')){
                        var filter = JSON.parse(current.get('filter'));
                        if(filter.integration != null){ 
                            if(window.sessionStorage && !sessionStorage.groupIntegrations && !sessionStorage.groupIntegrations.includes(filter.integration)) document.getElementById('new-system-message').style.display = "none";
                        }
                    }
                    document.getElementById('message').innerHTML = current.get('message')
                    var severity = current.get('severityLevel').toLowerCase();
                    var icon = severity == "information" ? "icon-info-sign" : severity == "warning" ? "icon-warning-sign" : severity == "error" ? "icon-fire" : "icon-red icon-fire";  
                    $('#sign').addClass(icon)
                }
            }
        }
        if ($('#new-system-message').is(':visible')) { return }
        if (!Core.apiToken && !Core.accessToken && !options.cssLoggedIn) return;
        if (Core.client.systemMessages.models.length > 0){
            for (var i = 0; i < Core.client.systemMessages.models.length; i++) {
                var systemMessage = Core.client.systemMessages.models[i]
                if(systemMessage.get('filter')){
                    var filter = JSON.parse(systemMessage.get('filter'));
                    if(filter.integration != null){ 
                        if(window.sessionStorage && sessionStorage.groupIntegrations && !sessionStorage.groupIntegrations.includes(filter.integration)) continue; 
                    }
                }
                if((Core.client.me.get('lastSystemMessage') == null || (Core.client.me.get('lastSystemMessage') != null && Core.client.me.get('lastSystemMessage') < systemMessage.get('startTime')))
                    && (systemMessage.get('endTime') == null || systemMessage.get('endTime') > Date.now()) && systemMessage.get('startTime') < Date.now()){
                    $('#new-system-message').html(Core.template('new-system-message-template')({
                        message: systemMessage.get('message')
                    })).attr('system-message-id', systemMessage.get('id')).slideDown(300);
                    document.getElementById('message').innerHTML =  systemMessage.get('message')
                    var severity = systemMessage.get('severityLevel').toLowerCase();
                    var icon = severity == "information" ? "icon-info-sign" : severity == "warning" ? "icon-warning-sign" : severity == "error" ? "icon-fire" : "icon-red icon-fire";  
                    $('#sign').addClass(icon)
                    break;
                }
            }
        }
    },

    loadGroupIntegrations: function(){
        if (window.sessionStorage && typeof sessionStorage.groupIntegrations == 'undefined') {
            sessionStorage.groupIntegrations = ''
            console.log("Load integrations")
            var promises = [];
            var integrations = []
            var self = this
            var uniqueGroupUuids = []
            Core.client.groups.filter(function(g){
                return _(Core.client.me.get("groupMemberships")).pluck("groupId").indexOf(g.get("id")) >= 0
            }).forEach(function(group){
                if (group.get("uuid") && !(group.get("uuid") in uniqueGroupUuids)){
                    uniqueGroupUuids.push(group.get("uuid"))
                }
                if (group.get("parentGroupUuid") && !(group.get("parentGroupUuid") in uniqueGroupUuids)){
                    uniqueGroupUuids.push(group.get("parentGroupUuid"))
                }
            })
            uniqueGroupUuids.forEach(function(groupUuid){
                promises.push($.ajax({
                    url: Connect.contextRoot + '/integration/group/' + groupUuid,
                    type: 'Get',
                    contentType: 'application/json'
                }).success(function(data) {
                    data.forEach(function(groupIntegration) {
                        if(!integrations.includes(groupIntegration.application)){
                            integrations.push(groupIntegration.application)
                        }
                    })
                }).error(function(error) {
                    debug.error('unable to fetch freetext questions: ', error);
                }));
            })
    
            Promise.all(promises).then(function(results) {
                sessionStorage.setItem('groupIntegrations', integrations);   
                self.checkSystemMessage()     
            });
        }
    },

    closeSystemMessage: function(){
        var self = this;
        var systemMessage = Core.client["systemMessages"];
        var id = $('#new-system-message').attr('system-message-id')
        var current = Core.client.systemMessages.get(id)
        document.getElementById('new-system-message').style.display = "none";
        $.ajax({
            url: Core.contextRoot + '/systemmessage/latest?timestamp=' + current.get('startTime'),
            type: 'PUT',
            contentType: 'application/json'
        }).success(function(){
            Core.client.me.set({lastSystemMessage: current.get('startTime')});
            systemMessage.fetchUpdates().done(function(){
                self.checkSystemMessage()
            })
        });
    },

    setMainView: function(view, tab, options) {
        var lastTab = this.tab;
        this.tab = tab;
        if (tab != lastTab && this.navbar && this.navbar.rendered) this.navbar.render();
        if (!options) options = {};
        if (!this.navbar && (Core.apiToken || options.navbar)) {
            this.navbar = new NavbarView();
            this.navbar.setElement($('.navbar .navbar-inner'));
            this.showNavbar();
        }
        if (Core.apiToken || Core.accessToken || options.cssLoggedIn) $('html').addClass('logged-in'); else $('html').removeClass('logged-in');
        if (this.view) {
            this.view.disable();
            this.view.setElement(null);
            if (this.view.cssClass) $('#body-content').removeClass(this.view.cssClass);
        }
        if (window.refreshInterval) {
            clearInterval(window.refreshInterval);
            delete window.refreshInterval;
        }
        $('#body-content').removeClass();
        view.setElement($('#body-content'));

        // Adjust body content width depending on main view settings
        if (!view.fullWidth && !options.fullWidth) $('#body-content').addClass('container');
        if (view.wideContainer || options.wideContainer) {
            if ($('body').width() > CoreUI.wideScreenWidth) {
                $('#body-content').width('98%');
            }
        } else {
            $('#body-content').width('');
        }
        if (view.bodyPadding || options.bodyPadding) {
            $('#body-content.container').addClass('body-padding');
        } else {
            $('#body-content.container').removeClass('body-padding');
        }

        if (view.cssClass) $('#body-content').addClass(view.cssClass);
        view.enable();
        if (view.resizeView) view.resizeView();
        window.view = this.view = view;

        // Set title based on location hash
        if (!$('html').hasClass('logged-in')) {
            document.title = '<%= environment.title %>';
        } else {
            var hash = location.hash.split('/',1)[0];
            hash = hash.length > 1 ? hash.split('/',1)[0].substring(1) : hash.substring(1);
            if (hash.indexOf('?') >= 0) hash = hash.substring(0, hash.substring('?'));
            if (hash == 'group') document.title = i18next.t('groupSettings');
			else if (hash == 'sales') document.title = i18next.t('salesDashboard');
            else if (hash.split('?',1)[0] == 'sendschedule') document.title = i18next.t('schedulePreviewTitle');
            else if (hash.indexOf('invoice') == 0) document.title = i18next.t('invoicing');
            else if (hash == 'remotesignature') document.title = i18next.t('remoteSignature');
            else if (hash && hash.length > 0) document.title = i18next.t(hash);
            else document.title = '<%= environment.title %>';
            if (this.navbar) this.navbar.setTitle(document.title);
        }

        if (window.ga) {
            try {
                var page = location.hash;
                if (page && page.length > 1) page = page.substring(1); // remove #
                if (page && page.indexOf('?') >= 0) page = page.substring(0, page.indexOf('?'));
                ga('set', 'page', page);
                ga('send', 'pageview');
                debug.log('send pageview', page);
            } catch (e) {
                console.error(e);
            }
        }

        return view;
    },

    showNavbar: function() {
        if (this.navbar) this.navbar.enable();
        $('.navbar').fadeIn();
        // TODO should be able to do this with css instead
        $('body').css({'padding-top': $(window).width() >= 980 ? '60px' : '60px'});
    },

    hideNavbar: function() {
        $('.navbar').hide();
        $('body').css({'padding-top': '0'});
    },

    changeActiveGroups: function(newGroupIds, primaryGroupId) {
        var self = this;
        var oldGroupIds = _(_(Core.client.me.get('groupMemberships')).where({active: true})).pluck('groupId');
        // TODO be smart if newGroupIds are a subset of oldGroupIds
        Core.client.me.changeActiveGroups(newGroupIds, primaryGroupId).success(function(data) {
            debug.log('change groups success');
            self.reloadMasterData(false);
            // tell other tabs - delay a bit to avoid cache miss for master data
            if (window.localStorage) setTimeout(function() {
                localStorage.setItem('changeActiveGroups', JSON.stringify(Core.client.me.toJSON()));
                delete sessionStorage.groupIntegrations
            }, 2500);
        });
    },

    reloadMasterData: function(keepCache) {
        this.lastReloadMasterData = new Date().getTime();
        Core.client.clear({keepMe: true, keepCache: keepCache});

        if (window.sessionStorage) Object.keys(sessionStorage).forEach(function (key) {
            if (key != 'core_apiToken' && key.indexOf('impersonate') < 0) {
                sessionStorage.removeItem(key);
                console.log(key);
            }
        });

        Core.client.groups.getCachedOrFetchIfNotPaginated();
        this.tick();
        this.openSocket();
        this.navbar.change();
        // TODO this (reload route) or trigger event and have all views listen to it?
        Backbone.history.loadUrl();
    },

});
